import { Component } from '@angular/core';
import {
  ForgotPasswordService,
  ForgotState,
} from '../../../shared/services/forgotpassword/forgotpassword';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Botmaa } from '../../../shared/components/botmaa/botmaa';

@Component({
  selector: 'app-rightsection',
  standalone: true,
  // CommonModule provides NgIf, NgFor, AsyncPipe, class bindings, etc.
  imports: [CommonModule, ReactiveFormsModule, FormsModule, Botmaa],
  templateUrl: './rightsection.html',
  styleUrls: ['./rightsection.scss'],
})
export class Rightsection {
  stage$: Observable<ForgotState>; // ✅ Strongly typed

  constructor(private svc: ForgotPasswordService) {
    this.stage$ = this.svc.stage$; // ✅ Angular now knows it has a `.stage` property
  }
}
